/*
 *
 * MerchantSearch
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 21-Nov-2024
 */

import MerchantSearch from './MerchantSearch'

export default MerchantSearch
